var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"py-2":"","xs12":""}},[_c('div',{staticClass:"text-xs-center app-modal-title-icon"},[_c('v-icon',{staticClass:"warning--text",attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-5":"","py-2":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }